import { render, staticRenderFns } from "./PxListaSelecaoFornecedores.vue?vue&type=template&id=1880fd82&"
import script from "./PxListaSelecaoFornecedores.vue?vue&type=script&lang=js&"
export * from "./PxListaSelecaoFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports